import React from 'react';
import classNames from 'classnames';
import styles from './button.module.scss';
import { FaApple } from 'react-icons/fa';

export default ({
  children,
  type,
  dimmed,
  onClick,
  handleSubmit,
  submit,
  className,
  ...props
}) => {
  const click = submit
    ? handleSubmit(values => submit({ ...values }))
    : onClick;
  return (
    <button
      className={classNames(
        styles[type],
        { [styles.dimmed]: dimmed },
        className,
      )}
      type="button"
      {...props}
      onClick={click}
    >
      {type === 'apple' && <FaApple className={styles.appleLogo} />}
      {children}
    </button>
  );
};
